import React from 'react';
import logoFish from '../assets/logo-fish.png';

const LINE_LINK = 'https://lin.ee/XWd6B6c';

export default function NotInLineGate() {
  return (
    <div style={styles.shell}>
      <div style={styles.card}>
        <div style={styles.orb} aria-hidden="true" />

        {/* Brand logo */}
        <div style={styles.fishWrap}>
          <img src={logoFish} alt="ปลาทองช่วยจำ" style={styles.logoImg} />
        </div>

        <span style={styles.pill}>Memmany</span>
        <h1 style={styles.title}>ปลาทองช่วยจำ</h1>
        <p style={styles.tagline}>เรื่องยุ่ง ๆ ให้ปลาทองช่วยจำให้</p>

        <div style={styles.divider} />

        <p style={styles.message}>
          แอปนี้ใช้งานผ่าน <strong>LINE</strong> เท่านั้น<br />
          กรุณาเพิ่มเพื่อนและเปิดผ่าน LINE
        </p>

        {/* QR code */}
        <div style={styles.qrWrap}>
          <img
            src={`https://qr-official.line.me/gs/M_${LINE_LINK.split('/').pop()}_GW.png`}
            alt="LINE QR Code"
            style={styles.qr}
            onError={(e) => { e.currentTarget.style.display = 'none'; }}
          />
          <p style={styles.qrCaption}>สแกน QR เพื่อเพิ่มเพื่อน</p>
        </div>

        <a href={LINE_LINK} style={styles.lineBtn}>
          <LineIcon />
          เปิดใน LINE
        </a>

        <p style={styles.hint}>หากกดแล้วไม่มีอะไรเกิดขึ้น กรุณาเปิดแอป LINE ก่อน</p>
      </div>
    </div>
  );
}

function LineIcon() {
  return (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ flexShrink: 0 }}>
      <path d="M19.365 9.863c.349 0 .63.285.63.631 0 .345-.281.63-.63.63H17.61v1.125h1.755c.349 0 .63.283.63.63 0 .344-.281.629-.63.629h-2.386c-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63h2.386c.346 0 .627.285.627.63 0 .349-.281.63-.63.63H17.61v1.125h1.755zm-3.855 3.016c0 .27-.174.51-.432.596-.064.021-.133.031-.199.031-.211 0-.391-.09-.51-.25l-2.443-3.317v2.94c0 .344-.279.629-.631.629-.346 0-.626-.285-.626-.629V8.108c0-.27.173-.51.43-.595.06-.023.136-.033.194-.033.195 0 .375.105.495.254l2.462 3.33V8.108c0-.345.282-.63.63-.63.345 0 .63.285.63.63v4.771zm-5.741 0c0 .344-.282.629-.631.629-.345 0-.627-.285-.627-.629V8.108c0-.345.282-.63.63-.63.346 0 .628.285.628.63v4.771zm-2.466.629H4.917c-.345 0-.63-.285-.63-.629V8.108c0-.345.285-.63.63-.63.348 0 .63.285.63.63v4.141h1.756c.348 0 .629.283.629.63 0 .344-.281.629-.629.629M24 10.314C24 4.943 18.615.572 12 .572S0 4.943 0 10.314c0 4.811 4.27 8.842 10.035 9.608.391.082.923.258 1.058.59.12.301.079.766.038 1.08l-.164 1.02c-.045.301-.24 1.186 1.049.645 1.291-.539 6.916-4.078 9.436-6.975C23.176 14.393 24 12.458 24 10.314" />
    </svg>
  );
}

const styles = {
  shell: {
    minHeight: '100dvh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '24px 16px',
    background: 'linear-gradient(135deg, #fff8f3 0%, #e9f7fb 100%)',
  },
  card: {
    position: 'relative',
    background: 'rgba(255,255,255,0.92)',
    borderRadius: 28,
    padding: '36px 28px 28px',
    maxWidth: 360,
    width: '100%',
    textAlign: 'center',
    boxShadow: '0 24px 60px rgba(31,60,83,0.13)',
    border: '1px solid rgba(255,255,255,0.8)',
    overflow: 'hidden',
  },
  orb: {
    position: 'absolute',
    top: -60,
    right: -60,
    width: 200,
    height: 200,
    borderRadius: '50%',
    background: 'radial-gradient(circle, rgba(242,105,33,0.15) 0%, transparent 70%)',
    pointerEvents: 'none',
  },
  fishWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 8,
  },
  logoImg: {
    width: 110,
    height: 110,
    objectFit: 'contain',
    borderRadius: 24,
  },
  pill: {
    display: 'inline-block',
    background: 'linear-gradient(135deg, #ff8a3d, #f05b1d)',
    color: '#fff',
    borderRadius: 999,
    padding: '3px 14px',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    marginBottom: 8,
  },
  title: {
    margin: '0 0 4px',
    fontSize: 26,
    fontWeight: 700,
    color: '#1f2a33',
    fontFamily: "'Kanit', 'Sarabun', sans-serif",
  },
  tagline: {
    margin: '0 0 20px',
    fontSize: 14,
    color: '#5f6b73',
    fontFamily: "'Sarabun', sans-serif",
  },
  divider: {
    height: 1,
    background: '#e8f0f3',
    margin: '0 0 20px',
  },
  message: {
    fontSize: 15,
    color: '#1f2a33',
    lineHeight: 1.7,
    margin: '0 0 20px',
    fontFamily: "'Sarabun', sans-serif",
  },
  qrWrap: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    marginBottom: 20,
  },
  qr: {
    width: 160,
    height: 160,
    borderRadius: 12,
    border: '1px solid #d0e4ea',
  },
  qrCaption: {
    fontSize: 12,
    color: '#9aa6ad',
    margin: 0,
    fontFamily: "'Sarabun', sans-serif",
  },
  lineBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 10,
    background: '#06C755',
    color: '#fff',
    textDecoration: 'none',
    borderRadius: 14,
    padding: '13px 28px',
    fontWeight: 700,
    fontSize: 16,
    width: '100%',
    boxSizing: 'border-box',
    boxShadow: '0 8px 20px rgba(6,199,85,0.3)',
    fontFamily: "'Sarabun', sans-serif",
  },
  hint: {
    marginTop: 14,
    fontSize: 11,
    color: '#9aa6ad',
    fontFamily: "'Sarabun', sans-serif",
  },
};
